import { render } from "./BlockFooter.vue?vue&type=template&id=1e3ec995&scoped=true"
import script from "./BlockFooter.vue?vue&type=script&lang=js"
export * from "./BlockFooter.vue?vue&type=script&lang=js"

import "./BlockFooter.vue?vue&type=style&index=0&id=1e3ec995&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3ec995"]])

export default __exports__